import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Tabs, Tab } from "@mui/material";
import Positions from './Positions';
import SearchButton from './SearchButton';
import Price from './Price';
import Prefectures from './Prefecture';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function SearchTabs({
  PriceComponent = Price,
  type = "project",
  tabLabels = { roles: "ポジション", price: "金額", prefecture: "勤務地" },
  roles,
  prefByArea,
  selectedRoleIds,
  setSelectedRoleIds,
  priceFilter,
  setPriceFilter,
  selectedPrefectureIds,
  setSelectedPrefectureIds,
  onSearch,
  onClose,
}) {
  const [value, setValue] = useState(0);
  const handleChange = (_, newValue) => setValue(newValue);

  const priceLabel = type === "job" ? "希望年収" : "希望金額";

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",              // ← Modal 側が高さを持っている前提（80vh など）
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* タブ */}
      <Box sx={{ borderBottom: 1, borderColor: "divider", flexShrink: 0 }}>
        <Tabs value={value} onChange={handleChange} aria-label="検索条件のタブ">
          <Tab label={tabLabels.roles} {...a11yProps(0)} />
          <Tab label={tabLabels.price} {...a11yProps(1)} />
          <Tab label={tabLabels.prefecture} {...a11yProps(2)} />
        </Tabs>
      </Box>

      {/* 中身（スクロール領域） */}
      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <CustomTabPanel value={value} index={0}>
          <Positions
            roles={roles}
            selectedRoleIds={selectedRoleIds}
            onChangeSelectedRoleIds={setSelectedRoleIds}
          />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={1}>
          <PriceComponent
            priceFilter={priceFilter}
            setPriceFilter={setPriceFilter}
            label={priceLabel}
          />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={2}>
          <Prefectures
            prefByArea={prefByArea}
            selectedIds={selectedPrefectureIds}
            setSelectedIds={setSelectedPrefectureIds}
          />
        </CustomTabPanel>
      </Box>

      {/* フッター（下固定・固定値なし） */}
      <Box
        sx={{
          flexShrink: 0,
          display: "flex",
          justifyContent: "center",
          py: 2,
          bgcolor: "#fff",
        }}
      >
        <SearchButton
          onClick={() => {
            onSearch?.({
              roleIds: selectedRoleIds,
              prefectureIds: selectedPrefectureIds,
              priceFilter,
            });
            onClose?.();
          }}
          type={type}
        />
      </Box>
    </Box>
  );
}

SearchTabs.propTypes = {
  PriceComponent: PropTypes.elementType,
  type: PropTypes.oneOf(["project", "job"]),
  tabLabels: PropTypes.shape({
    roles: PropTypes.string,
    price: PropTypes.string,
    prefecture: PropTypes.string,
  }),

  roles: PropTypes.array,
  prefByArea: PropTypes.object,

  selectedRoleIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  setSelectedRoleIds: PropTypes.func,

  priceFilter: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  setPriceFilter: PropTypes.func,

  selectedPrefectureIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  setSelectedPrefectureIds: PropTypes.func,

  onSearch: PropTypes.func,
  onClose: PropTypes.func,
};

export default SearchTabs;